define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/StorageUtil',
	
	'model/Error',
	'model/ErrorType',
	
	'state/UIState',
	
	'service/UIStateManager',
	
	'view/SplashScreenView',
	'view/TimeoutErrorView',
	'view/ControlBarView',
	
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/ErrorState_strings'
], function (
	Logger,
	Util,
	StorageUtil,
	
	Error,
	ErrorType,
	
	UIState,
	
	UIStateManager,
	
	SplashScreenView,
	ErrorView,
	ControlBarView,
	
	CommonStrings,
	Strings
) {
	'use strict';

	/**
	 * ErrorState class
	 */
	function ErrorState(uiStateManager) {
		var _uiStateManager,
			_splashScreenView = new SplashScreenView(),
			_errorView = new ErrorView(),
			_controlBarView = new ControlBarView('skIdS_control-bar-error'),
			_nextButton,
			_nextCallback;

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

		_splashScreenView.disableAnimation();
		
		_controlBarView.addButton(Strings.ids, function () {
			_uiStateManager.change('identities_overview');
		},0);
		
		var _url = StorageUtil.read("origin_url");
		var _backButton = _controlBarView.addButton(Strings.back, function () {
			if (_url !== null) {
				window.location = _url;
			}
			StorageUtil.remove("origin_url");
		},2);


		UIState.call(this, 'timeout_error');


		// public methods

		this.title = function () {
			return Strings.TimeoutError;
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [ _splashScreenView, _errorView ];
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback, error) {
			if (_url === null) {
				_backButton.hide();
			}
			
			//TODO: Log error
			_errorView.update(error);

			Util.callCallbacks(doneCallback);
		};

		this.leave = function (doneCallback) {

			Util.callCallbacks(doneCallback);
		};
	};

	ErrorState.prototype = Object.create(UIState.prototype);

	return ErrorState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/TimeoutErrorState.js
// module id = 308
// module chunks = 3